<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="printTagAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalTagVisible" :vm-is-valid="!$v.form.$invalid" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-model="form.attention" :danger="!$v.form.attention.required" danger-text="Attention is required" label='Atención a' placeholder="Ingresa a quien va dirigido")
      vm-col(vm-justify="center", vm-align="center", vm-lg=12)
        b-form-group
          vm-select(:placeholder='$t("quotations.customer_address_id_placeholder")' :warning="customerAddresses.length == 0" warning-text="Este cliente no tiene direcciones" v-model="form.customer_address_id" :label='$t("quotations.customer_address_id")')
            vm-select-item(:key="index" :value="item.id" :text="item.address_name" v-for="(item,index) in customerAddresses")
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalTag',
  props: {
    title: {
      type: String,
      default: 'Imprimir Tag'
    },
    id: {
      type: Number,
      default: () => 0
    }
  },
  data: () => ({
    customerAddresses: [],
    form: {
    },
    props: {}
  }),
  validations: {
    form: {
      attention: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalTagVisible',
      'salesCatalog',
      'sale'
    ])
  },
  watch: {
    isModalTagVisible (flag) {
      if (flag) {
        this.loadSale({ id: this.id })
      }
    },
    sale (sale) {
      var customer = this.salesCatalog.customers.find((customer) => customer.id === sale.customer_id)
      if (customer !== undefined) {
        this.customerAddresses = customer.addresses
      }
    }
  },
  methods: {
    ...mapActions([
      'printTag',
      'setModalTagVisible',
      'loadSale'
    ]),
    remove (item) {
      this.form.emails.splice(this.form.emails.indexOf(item), 1)
    },
    printTagAction () {
      this.printTag({ model: this.model, id: this.id, form: this.form })
      this.customerAddresses = []
      this.form = {}
    },
    close () {
      this.setModalTagVisible(false)
      this.customerAddresses = []
      this.form = {}
    }
  }
}
</script>

<style lang="scss">
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
.ddrop {
  height: 15vh;
  width: 100%;
  border: dashed 1px;
  border-radius: 10px;
  padding: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  ul {
    list-style-type: none;
  }
}
.hide {
  display: none;
}
</style>
